import {Component, Input, OnInit} from '@angular/core';
import {JP} from "../../helpers/jp";
import {IDocument} from "../../interfaces/document.definition";
import {paramsHelper} from "../../helpers/params-helper";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {localeUtils} from "../../helpers/locale-utils";
import {CHAR_EMOTIONS_LIST} from "../../enums/e-scene-types";

@Component({
  selector: 'nv-picture-params',
  templateUrl: './nv-picture-params.component.html',
  styles: []
})
export class NvPictureParamsComponent implements OnInit {

  CHAR_EMOTIONS_LIST = CHAR_EMOTIONS_LIST;

  loadedTalkingHeads:IDocument[] = [];

  private _document: any;
  private _pointer: string;
  private _enabled: boolean;
  private _title: string;
  private _spineEnabled:boolean;

  @Input() set document(v: any) {
    //console.log('set doc');
    this._document = v;
    this.updateModel();
  }
  get document() {
    return this._document;
  }

  @Input() set pointer(v: string) {
    console.log('set pointer!');
    this._pointer = v;
    this.updateModel();
  }
  get pointer() {
    return this._pointer;
  }

  @Input() set title(v: string) {
    this._title = v;
  }
  get title(): string {
    return this._title || "No title";
  }


  constructor(private collectionService: CollectionService) {

  }

  ngOnInit() {
    this.loadTalkingHeads();
  }

  onCheckboxUpdated(val:boolean) {
    this.enabled = val;
    if (this.enabled)
    {
      JP.set(this.document, this.pointer, {bgImage:""});
    }
    else if (JP.has(this.document, this.pointer))
    {
      JP.remove(this.document, this.pointer);
    }
  }

  onSpineCheck(val:boolean){
    this.spineEnabled = val;
    if (this.spineEnabled)
    {
      JP.set(this.document, this.pointer+"/spine",  {});
    }
    else if (JP.has(this.document, this.pointer+"/spine"))
    {
      JP.remove(this.document, this.pointer+"/spine");
    }
  }

  private loadTalkingHeads()
  {
    // console.log(`load th`);
    const search = paramsHelper
      .search()
      .addStringParam("category", GO_CATEGORIES.TALKING_HEAD)
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.loadedTalkingHeads = r.documents.concat([{_id:"", id: -1}]);
          // console.log(`th loaded ${JSON.stringify(this.loadedTalkingHeads)}`);
          //this.updateTalkingHeadsSelects();
        });
  }

  getTalkingHeadLabel(talkingHead:IDocument):string
  {
    if (talkingHead.id >= 0)
    {
      return localeUtils.findValue("name", talkingHead);
    }
    else
    {
      return "NONE";
    }
    //return talkingHead["locales"][0]["value"][0];
  }

  private updateModel(): void {

    if (this.document && this.pointer)
    {
      this.enabled = JP.has(this.document, this.pointer);
      this.spineEnabled = JP.has(this.document, this.pointer + "/spine");
    }
    else
    {
      this.enabled = false;
    }
  }

  set enabled(val:boolean)
  {
    this._enabled = val;
    JP.set(this.document, "/admin/hasPicture", val);
  }

  get enabled():boolean
  {
    return this._enabled;
  }

  set spineEnabled(val:boolean)
  {
    this._spineEnabled = val;
    console.log(`spine enabled ${val}`);
    JP.set(this.document, "/admin/hasSpine", val);
  }

  get spineEnabled():boolean
  {
    return this._spineEnabled;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-picture-params/nv-picture-params.component.ts